import { useState, useEffect, useCallback } from 'react'
import styled, { useTheme } from 'styled-components'
import { Flex, Text, Button } from '@pancakeswap/uikit'
import { ethers } from 'ethers'
import abi from '../../../abi/lottery.abi.json'
import { useWeb3React } from '@web3-react/core'

const StyledCard = styled(Flex)`
  background: ${({ theme }) => theme.colors.cardBackground};
  border-radius: 16px;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-shadow: ${({ theme }) => (theme.isDark ? '' : '8px 12px 12px rgba(15, 20, 30, 0.12)')};
`

const StyledHardText = styled(Text)`
  color: ${({ theme }) => theme.colors.hardTextColor};
`

const StyledSoftText = styled(Text)`
  color: ${({ theme }) => theme.colors.softTextColor};
`

const StyledHr = styled.hr`
  border-color: ${({ theme }) => theme.colors.hrColor};
  border-size: 1px;
  border-style: solid;
  width: 90%;
  margin-top: 20px;
`

const moneyFormat = (value) => {
  return (+value)
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

const Dividens = ({ genericprovider }) => {
  const theme = useTheme()
  const contractAddress = '0x043C2e5100A7157c36D677af0BbD62F76bB7E7D7'

  const [pendingDividens, setPendingDividens] = useState(-1)
  const [claimableDividens, setClaimableDividens] = useState(-1)
  const [claimedDividens, setClaimedDividens] = useState(-1)

  const { account, library } = useWeb3React()
  // const account = "0x780b447c28ec8d7c531af647b9399f8b8100409c";

  const claimDividens = useCallback(async () => {
    const originalClaimableDividens = JSON.parse(JSON.stringify(claimableDividens))
    setClaimableDividens(0)
    try {
      const contract = new ethers.Contract(contractAddress, abi, library.getSigner())
      const tx = await contract.functions.claimDividends()
      await tx.wait()
      contract.functions
        .calculateUnallocatedDividends(account)
        .then((unallocatedDividensResp) => {
          contract.functions
            .dividendsAllocation(account)
            .then((dividensAllocationRespo) => {
              setClaimableDividens(
                +ethers.utils.formatUnits(unallocatedDividensResp[0]) +
                  +ethers.utils.formatUnits(dividensAllocationRespo[0]),
              )
            })
            .catch((err) => {
              setClaimableDividens(originalClaimableDividens)
            })
        })
        .catch((err) => {
          setClaimableDividens(originalClaimableDividens)
        })
    } catch (err) {
      setClaimableDividens(originalClaimableDividens)
    }
  }, [account, library, setClaimableDividens])

  useEffect(() => {
    if (account) {
      const contract = new ethers.Contract(contractAddress, abi, genericprovider)
      contract.functions
        .calculatePendingDividends(account)
        .then((resp) => {
          setPendingDividens(+ethers.utils.formatUnits(resp[0]))
        })
        .catch((err) => {
          setPendingDividens(0)
        })
    }
  }, [account])

  useEffect(() => {
    if (account) {
      const contract = new ethers.Contract(contractAddress, abi, genericprovider)
      contract.functions
        .calculateUnallocatedDividends(account)
        .then((unallocatedDividensResp) => {
          contract.functions
            .dividendsAllocation(account)
            .then((dividensAllocationRespo) => {
              setClaimableDividens(
                +ethers.utils.formatUnits(unallocatedDividensResp[0]) +
                  +ethers.utils.formatUnits(dividensAllocationRespo[0]),
              )
            })
            .catch((err) => {
              setClaimableDividens(0)
            })
        })
        .catch((err) => {
          setClaimableDividens(0)
        })
    }
  }, [account])

  useEffect(() => {
    if (account) {
      const contract = new ethers.Contract(contractAddress, abi, genericprovider)
      contract.stableCoin().then((stableCoinResp) => {
        const stableCoin = stableCoinResp.toString()
        contract.functions
          .totalClaimedDividends(stableCoin, account)
          .then((resp) => {
            setClaimedDividens(+ethers.utils.formatUnits(resp[0]))
          })
          .catch((err) => {
            setClaimedDividens(0)
          })
      })
    }
  }, [account])

  return (
    <StyledCard style={{ flexDirection: 'column' }}>
      <StyledHardText bold style={{ marginTop: 20 }}>
        Dividends
      </StyledHardText>
      <StyledHr />
      <Flex width="90%" mt="22px" mb="20px">
        <StyledSoftText style={{ flexGrow: 1 }}>Pending</StyledSoftText>
        <Text>
          {account ? (pendingDividens === -1 ? 'Loading...' : `${moneyFormat(pendingDividens)} USDT`) : '0 USDT'}
        </Text>
      </Flex>
      <Flex width="90%" mb="20px">
        <StyledSoftText style={{ flexGrow: 1 }}>Claimable</StyledSoftText>
        <Text>
          {account ? (claimableDividens === -1 ? 'Loading...' : `${moneyFormat(claimableDividens)} USDT`) : '0 USDT'}
        </Text>
      </Flex>
      <Flex width="90%" mb="20px">
        <StyledSoftText style={{ flexGrow: 1 }}>Claimed</StyledSoftText>
        <Text>
          {account ? (claimedDividens === -1 ? 'Loading...' : `${moneyFormat(claimedDividens)} USDT`) : '0 USDT'}
        </Text>
      </Flex>
      <Flex style={{ gap: 20, marginBottom: 20 }}>
        <Button
          disabled={claimableDividens <= 0}
          onClick={claimDividens}
          style={{ marginTop: 16, width: '200px', borderRadius: 16 }}
        >
          Claim Dividends
        </Button>
      </Flex>
    </StyledCard>
  )
}

export default Dividens
